{
  "footer": {
    "alreadyPartner": "Déjà partenaire ?",
    "back": "Précédent",
    "letsgo": "C'est parti !",
    "login": "Connectez-vous",
    "next": "Suivant",
    "readMore": "En savoir plus",
    "signUp": "S'inscrire"
  },
  "formErrors": {
    "address": "Cette adresse est introuvable. Veuillez entrer une adresse existante",
    "businessName": "Ce nom est déjà utilisé. Veuillez en choisir un autre",
    "email": "Cet email est déjà utilisé.",
    "verificationCode": "Code invalide"
  },
  "global": {
    "title": "Rejoindre Treatwell"
  },
  "input": {
    "businessName": {
      "invalid": "Nom de l'entreprise trop long",
      "label": "Nom de l'entreprise",
      "required": "Champ requis"
    },
    "businessSegment": {
      "aesthetics": "Esthétique",
      "barber": "Barbier",
      "beautician": "Salon de beauté",
      "hair-removal": "Épilation",
      "hairdresser": "Coiffure",
      "massage": "Massage",
      "nails": "Onglerie",
      "primary": "Spécialité",
      "required": "Sélectionnez-en au moins 1",
      "spa": "Spa"
    },
    "businessType": {
      "dedicatedSpaceCheckbox": "Je confirme disposer d'un espace séparé et dédié aux soins chez moi",
      "home": "A domicile <0>- vos clients viennent chez vous</0>",
      "mobile": "Mobile <0>- vous allez chez vos clients</0>",
      "mobileCheckbox": "Je souhaite utiliser Treatwell uniquement pour l’agenda et PAS pour la plateforme de réservations Treatwell.fr",
      "mobileMessage": "Malheureusement, en raison de limitations, notre plateforme peut uniquement mettre en ligne des entreprises ayant une adresse fixe.",
      "required": "Sélectionnez-en 1",
      "shop": "En salon <0>- vos clients viennent à votre salon</0>"
    },
    "city": {
      "invalid": "Ville trop longue",
      "label": "Ville",
      "required": "Champ requis"
    },
    "country": {
      "label": "Pays",
      "required": "Champ requis"
    },
    "email": {
      "invalid": "Veuillez saisir une adresse email valide",
      "label": "Email",
      "required": "Champ requis"
    },
    "firstName": {
      "invalid": "Merci de ne pas utiliser de caractères spéciaux",
      "label": "Prénom",
      "required": "Champ requis"
    },
    "lastName": {
      "invalid": "Merci de ne pas utiliser de caractères spéciaux",
      "label": "Nom de famille",
      "required": "Champ requis"
    },
    "marketing": {
      "label": "Cochez cette case pour recevoir des communications afin de faire grandir votre entreprise avec des conseils d'expert."
    },
    "password": {
      "hint": "8 caractères minimum",
      "invalid": "Doit faire au moins 8 caractères",
      "label": "Mot de passe",
      "required": "Champ requis"
    },
    "phoneNumber": {
      "invalid": "Numéro de téléphone invalide",
      "label": "Téléphone",
      "required": "Champ requis"
    },
    "postalCode": {
      "invalid": "Code postal trop long",
      "label": "Code postal",
      "required": "Champ requis"
    },
    "privacy": {
      "label": "En vous inscrivant au compte Freemium vous acceptez notre <0>politique de confidentialité</0> et les conditions générales énoncées sur notre <1>site web</1>."
    },
    "searchBusiness": {
      "label": "Écrivez le nom de votre entreprise"
    },
    "street": {
      "invalid": "Adresse trop longue",
      "label": "Adresse",
      "required": "Champ requis"
    }
  },
  "salesMode": {
    "enterPassword": "Entrez le mot de passe pour le mode sales",
    "invalidPassword": "Mot de passe invalide"
  },
  "stepContext": {
    "attractNewClients": "Attirez de nouveaux clients",
    "buildRelationships": "Créez des relations encore meilleures avec vos clients",
    "growBusiness": "Faites croître votre entreprise avec élégance",
    "manageAppointments": "Gérez tous vos rendez-vous en déplacement",
    "prompt": "Vous n'êtes plus qu'à quelques étapes (et environ 3 minutes) de rejoindre plus de 75 000 salons qui gèrent leur établissement, développent leur clientèle et augmentent leur chiffre d'affaires.<br /><br />Avec Treatwell, vous pourrez :",
    "prompt2": "...et bien plus encore",
    "title": "<0>Rejoindre Treatwell</0> - la plus grande plateforme de salons de coiffure et de beauté en Europe - cela n'a jamais été aussi simple."
  },
  "stepCounter": {
    "step0": "Étape 1",
    "step1": "Étape 1",
    "step2": "Étape 2",
    "step3": "Étape 3",
    "step4": "Étape 4",
    "step5": "Félicitations"
  },
  "stepEmailVerification": {
    "resend": "Renvoyer",
    "subTitle1": "Entrez simplement le code pour terminer votre inscription.",
    "subTitle2": "Pas reçu ?",
    "title": "<0>C'est bientôt fini,</0> on vous a envoyé un email avec un code à 6 chiffres!"
  },
  "stepError": {
    "accountCreation": "la création de votre compte",
    "body": "Nous rencontrons des problèmes.\nVeuillez patienter et réessayer.",
    "bodyWithError": "Nous rencontrons des problèmes avec {{reason}}.\nVeuillez patienter et réessayer.",
    "button": "Réessayer",
    "title": "Oups, il y a eu un problème !"
  },
  "stepFinal": {
    "joke1Punchline": "Pour être sûrs d’avoir une coupe.",
    "joke1Setup": "Pourquoi les footballeurs vont-ils souvent chez le coiffeur ?",
    "joke2Punchline": "Friser le ridicule en rasant les murs…",
    "joke2Setup": "Quel est le comble du coiffeur ?",
    "joke3Punchline": "La raie.",
    "joke3Setup": "Quel est le poisson le mieux coiffé ?",
    "joke4Punchline": "Se faire des mèches.",
    "joke4Setup": "Quelle est la coupe de cheveux préférée de la dynamite ?",
    "joke5Punchline": "Se crêper le chignon !",
    "joke5Setup": "Quel est le comble pour deux coiffeuses ?",
    "subTitle": "En attendant voici quelques blagues qui décoiffent",
    "title": "Merci, on créé votre compte !<br />Cela prendra environ <0>deux minutes...</0>"
  },
  "stepFinalRedirectLogin": {
    "alternativeButton": "S'inscrire",
    "alternativeMessage": "Utilisez-vous cette adresse pour inscrire un nouvel établissement ?",
    "button": "Se connecter",
    "message": "<0>Bonne nouvelle !</0> Vous avez déjà un compte chez nous."
  },
  "stepFourForm": {
    "prompt1": "Nous allons utiliser ces informations afin de créer votre compte et nous vous contacterons si besoin",
    "title": "Enfin, parlez-nous de vous"
  },
  "stepOneForm": {
    "prompt1": "Cherchez le nom de votre entreprise",
    "title": "Parlez-nous de votre entreprise"
  },
  "stepOneSearch": {
    "addManually": "Vous ne trouvez pas votre entreprise ? <0>Ajoutez-la manuellement</0>",
    "prompt1": "Tapez le nom de votre entreprise",
    "title": "Parlez-nous de votre entreprise"
  },
  "stepThreeForm": {
    "title": "Quel genre d'entreprise gérez-vous ?"
  },
  "stepTwoForm": {
    "prompt1": "Choisissez tous ceux qui s'appliquent, votre spécialité en premier",
    "title": "Quels services offrez-vous?"
  }
}